<template>
  <div>
    <el-dialog
      top="6vh"
      width="90%"
      :visible="dialogVisible"
      :show-close="false"
      :before-close="() => (dialogVisible = false)"
    >
      <div slot="title" class="list-header">
        <h3 style="display: inline">计算公式列表</h3>
        <div style="display: inline-block">
          <el-button :dialogLoading="dialogLoading" size="mini" @click="addNewRow" v-if="!readonly">
            <i class="el-icon-plus"></i> 新增公式
          </el-button>
          <el-button :dialogLoading="dialogLoading" type="primary" size="mini" @click="save" style="margin-right: 24px" v-if="!readonly">
            <i class="el-icon-check"></i> 保存
          </el-button>
          <el-divider direction="vertical" v-if="!readonly"></el-divider>
          <el-button :dialogLoading="dialogLoading" size="mini" style="margin-left: 24px" @click="() => (dialogVisible = false)">关闭</el-button>
        </div>
      </div>

      <div class="calculate-list">
        <el-table ref="table" :data="tableData" size="mini" row-key="id" border stripe style="width: 100%" height="500px">
          <el-table-column type="index" label="#" width="60" align="center" fixed="left" v-if="!readonly">
            <template>
              <i class="el-icon-rank drag-icon" style="cursor: move"></i>
            </template>
          </el-table-column>

          <el-table-column type="index" label="序号" width="50" align="center" fixed="left"></el-table-column>

          <el-table-column prop="formConfigId" label="表名*" min-width="140" align="center" fixed="left">
            <template slot-scope="scope">
              <div class="input-with-error">
                <el-select
                  v-model="scope.row.formConfigId"
                  size="small"
                  style="width: 100%"
                  @change="() => handleFormConfigChange(scope.row)"
                  :disabled="readonly"
                >
                  <el-option v-for="item in configData" :key="item.id" :label="item.header" :value="item.id"></el-option>
                </el-select>
                <div v-if="scope.row.validationErrors && scope.row.validationErrors.formConfigId" class="error-message">
                  {{ scope.row.validationErrors.formConfigId }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="fieldName" label="目标字段*" min-width="140" align="center" fixed="left">
            <template slot-scope="scope">
              <div class="input-with-error">
                <el-select v-model="scope.row.fieldName" size="small" :disabled="readonly" style="width: 100%">
                  <el-option
                    v-for="item in getFieldList(scope.row)"
                    :key="item.id"
                    :label="item.showName || item.itemShowName"
                    :value="item.fieldName || item.itemName"
                  ></el-option>
                </el-select>
                <div v-if="scope.row.validationErrors && scope.row.validationErrors.fieldName" class="error-message">
                  {{ scope.row.validationErrors.fieldName }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="triggerField" label="条件字段" min-width="180" align="center" fixed="left">
            <template slot-scope="scope">
              <div class="input-with-error">
                <el-select
                  v-if="!readonly"
                  v-model="scope.row.triggerField"
                  size="small"
                  style="width: 100%"
                  :disabled="!scope.row.formConfigId"
                  clearable
                >
                  <el-option label="无" value="none"></el-option>
                  <el-option
                    v-for="item in getConditionFieldOptions(scope.row)"
                    :key="item.id"
                    :label="item.showName || item.itemShowName"
                    :value="`${scope.row.formConfigId},${item.id}`"
                  ></el-option>
                </el-select>
                <span v-else>{{ renderTriggerField(scope.row) }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="triggerFieldValue" label="条件值" min-width="340" align="center" fixed="left">
            <template slot-scope="scope">
              <div class="input-with-error">
                <div v-if="!readonly" class="trigger-value-editor">
                  <el-select v-model="scope.row.triggerValueType" size="small" class="trigger-type" :disabled="isTriggerAlways(scope.row.triggerField)">
                    <el-option label="固定值" value="static"></el-option>
                    <el-option label="动态字段" value="dynamic"></el-option>
                  </el-select>

                  <el-select v-model="scope.row.triggerOperator" size="small" class="trigger-operator" :disabled="isTriggerAlways(scope.row.triggerField)">
                    <el-option v-for="item in triggerOperatorOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>

                  <el-input
                    v-if="scope.row.triggerValueType !== 'dynamic'"
                    v-model="scope.row.triggerFieldValue"
                    size="small"
                    class="trigger-value"
                    placeholder="请输入条件值"
                    :disabled="isValueInputDisabled(scope.row)"
                  ></el-input>

                  <el-select
                    v-else
                    v-model="scope.row.triggerFieldDynamic"
                    size="small"
                    class="trigger-value"
                    placeholder="请选择动态字段"
                    :disabled="isValueInputDisabled(scope.row) || !scope.row.formConfigId"
                  >
                    <el-option
                      v-for="item in getConditionFieldOptions(scope.row)"
                      :key="item.id"
                      :label="item.showName || item.itemShowName"
                      :value="`${scope.row.formConfigId},${item.id}`"
                    ></el-option>
                  </el-select>
                </div>
                <span v-else>{{ renderTriggerValue(scope.row) }}</span>

                <div v-if="scope.row.validationErrors && scope.row.validationErrors.triggerFieldValue" class="error-message">
                  {{ scope.row.validationErrors.triggerFieldValue }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="decimals" label="小数位" width="160" align="center">
            <template slot-scope="scope">
              <el-input-number v-if="!readonly" v-model="scope.row.decimals" :min="0" :max="10" size="small"></el-input-number>
              <span v-else>{{ scope.row.decimals }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="exclusionRule" label="舍入方式" width="120" align="center">
            <template slot-scope="scope">
              <el-select v-if="!readonly" v-model="scope.row.exclusionRule" size="small" style="width: 100%">
                <el-option label="四舍五入" value="round"></el-option>
                <el-option label="向上取整" value="ceil"></el-option>
                <el-option label="向下取整" value="floor"></el-option>
              </el-select>
              <span v-else>{{ exclusionRules[scope.row.exclusionRule] }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="showTemplate" label="计算公式" min-width="250" align="center">
            <template slot-scope="scope">
              <div v-if="!readonly" class="input-with-error">
                <el-input
                  v-model="scope.row.showTemplate"
                  size="small"
                  placeholder="请输入计算公式（必填）"
                  :required="true"
                  :disabled="true"
                  :validate-event="false"
                  class="formula-input"
                >
                  <i class="el-icon-edit el-input__icon" slot="suffix" @click="() => handleEditor(scope.row)"></i>
                </el-input>
                <div v-if="scope.row.validationErrors && scope.row.validationErrors.showTemplate" class="error-message">
                  {{ scope.row.validationErrors.showTemplate }}
                </div>
              </div>
              <span v-else>{{ scope.row.showTemplate }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="isEnable" label="启用" width="60" align="center" v-if="!readonly">
            <template slot-scope="scope" v-if="!readonly">
              <el-checkbox v-model="scope.row.isEnable" size="small" true-label="1" false-label="0"></el-checkbox>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="60" align="center" v-if="!readonly">
            <template slot-scope="scope">
              <i class="el-icon-delete" @click="deleteRow(scope.$index)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog title="公式编辑器" :visible.sync="showEditor" top="2vh" width="90%" fullscreen :footer="null" :close-on-click-modal="false">
      <calculate-editor v-model="editorRow.showTemplate" @close="showEditor = false" @confirm="handleConfirm" :available-variables="cascaderOption"></calculate-editor>
    </el-dialog>
  </div>
</template>

<script>
import clone from 'clone'
import Sortable from 'sortablejs'
import { renderDom } from '@/api/list'
import CalculateEditor from '../CalculateEditor/index.vue'
import { submitFormulaInfo } from '@/api/sysTem'
import { getFormulaList } from '@/api/detail'
import { getSession } from '@/utils/methods'

export default {
  name: 'CalculateList',
  components: { CalculateEditor },
  data() {
    return {
      readonly: false,
      showEditor: false,
      editorRow: {},
      dialogVisible: false,
      dialogLoading: false,
      formConfigId: null,
      username: getSession('users').username,
      tableData: [],
      configData: [],
      cascaderOption: [],
      triggerOperatorOptions: [
        { label: '=', value: '=' },
        { label: '!=', value: '!=' },
        { label: '>', value: '>' },
        { label: '>=', value: '>=' },
        { label: '<', value: '<' },
        { label: '<=', value: '<=' },
        { label: '包含', value: 'contains' },
        { label: '空', value: 'is_empty' },
        { label: '非空', value: 'not_empty' }
      ],
      exclusionRules: {
        round: '四舍五入',
        ceil: '向上取整',
        floor: '向下取整'
      },
      fixedWheelCleanupList: [],
      sortableInstance: null
    }
  },
  beforeDestroy() {
    this.removeFixedWheelSync()
    if (this.sortableInstance && typeof this.sortableInstance.destroy === 'function') {
      this.sortableInstance.destroy()
      this.sortableInstance = null
    }
  },
  methods: {
    normalizeTriggerField(triggerField) {
      if (Array.isArray(triggerField)) {
        if (triggerField.length === 0) return 'none'
        const list = triggerField.map(item => String(item == null ? '' : item).trim().toLowerCase())
        if (list.includes('none') || list.includes('无') || list.includes('null') || list.includes('undefined') || list.includes('')) {
          return 'none'
        }
        return triggerField
      }
      const text = String(triggerField == null ? '' : triggerField).trim()
      if (!text) return 'none'
      const lower = text.toLowerCase()
      if (lower === 'none' || text === '无' || lower === 'null' || lower === 'undefined') {
        return 'none'
      }
      return text
    },
    normalizeTriggerOperator(operator) {
      const raw = String(operator || '=').trim().toLowerCase()
      const mapping = {
        '==': '=',
        eq: '=',
        ne: '!=',
        '<>': '!=',
        gt: '>',
        gte: '>=',
        lt: '<',
        lte: '<=',
        empty: 'is_empty',
        isempty: 'is_empty',
        'is empty': 'is_empty',
        '空': 'is_empty',
        notempty: 'not_empty',
        'not empty': 'not_empty',
        '非空': 'not_empty',
        include: 'contains',
        includes: 'contains',
        like: 'contains',
        '包含': 'contains'
      }
      return mapping[raw] || raw || '='
    },
    handleShow(formConfigId) {
      this.dialogVisible = true
      this.formConfigId = formConfigId
      this.readonly = this.username !== 'admin'
      this.getFormulaList()
      renderDom(formConfigId).then(res => {
        this.configData = this.flattenTree([res])
        this.getCascader()
        this.$nextTick(() => this.initSortable())
      })
    },
    parseTriggerValue(item) {
      const normalizedOperator = this.normalizeTriggerOperator(item.triggerOperator || item.triggerCondition || '=')
      const triggerValueType = item.triggerValueType === 'dynamic' ? 'dynamic' : 'static'
      return {
        triggerValueType,
        triggerFieldValue: triggerValueType === 'dynamic' ? '' : (item.triggerFieldValue || ''),
        triggerFieldDynamic: triggerValueType === 'dynamic' ? String(item.triggerFieldDynamic || '') : '',
        triggerOperator: normalizedOperator
      }
    },
    formatTriggerValue(row) {
      if (this.isTriggerAlways(row.triggerField)) {
        return ''
      }
      if (row.triggerValueType === 'dynamic') {
        return ''
      }
      return row.triggerFieldValue || ''
    },
    getFormulaList() {
      getFormulaList({ id: this.formConfigId }).then(res => {
        const rawList = Array.isArray(res) ? res : []
        rawList.sort((a, b) => Number(a.serialNumber || 0) - Number(b.serialNumber || 0))
        this.tableData = rawList.map(item => ({
          ...item,
          showTemplate: item.showTemplate || item.template || '',
          triggerField: this.normalizeTriggerField(item.triggerField || 'none'),
          isEnable: item.isEnable !== undefined ? item.isEnable : '1',
          validationErrors: {},
          ...this.parseTriggerValue(item)
        }))
      })
    },
    initSortable() {
      this.$nextTick(() => {
        const table = this.$refs.table
        if (!table) return
        let tbody = table.$el.querySelector('.el-table__fixed .el-table__fixed-body-wrapper tbody')
        if (!tbody) tbody = table.$el.querySelector('.el-table__body tbody')
        if (!tbody) tbody = table.$el.querySelector('.el-table__fixed-body-wrapper tbody')
        if (!tbody) tbody = table.$el.querySelector('.el-table__body-wrapper tbody')
        if (!tbody) tbody = table.$el.querySelector('.el-table__body-wrapper')
        if (!tbody) return
        if (this.sortableInstance && typeof this.sortableInstance.destroy === 'function') {
          this.sortableInstance.destroy()
        }
        this.sortableInstance = Sortable.create(tbody, {
          handle: '.drag-icon',
          animation: 150,
          ghostClass: 'sortable-ghost',
          onEnd: event => this.handleDragEnd(event)
        })
        this.bindFixedWheelSync()
      })
    },
    removeFixedWheelSync() {
      if (!Array.isArray(this.fixedWheelCleanupList)) return
      this.fixedWheelCleanupList.forEach(fn => {
        if (typeof fn === 'function') fn()
      })
        this.fixedWheelCleanupList = []
    },
    syncSerialNumbers() {
      this.tableData.forEach((item, index) => {
        item.serialNumber = index
      })
    },
    bindFixedWheelSync() {
      this.removeFixedWheelSync()
      const table = this.$refs.table
      if (!table || !table.$el) return
      const mainBody = table.$el.querySelector('.el-table__body-wrapper')
      if (!mainBody) return
      const fixedWrappers = table.$el.querySelectorAll('.el-table__fixed-body-wrapper')
      fixedWrappers.forEach(wrapper => {
        const onWheel = e => {
          if (!mainBody) return
          e.preventDefault()
          if (e.deltaY) {
            mainBody.scrollTop += e.deltaY
          }
          if (e.deltaX) {
            mainBody.scrollLeft += e.deltaX
          }
        }
        wrapper.addEventListener('wheel', onWheel, { passive: false })
        this.fixedWheelCleanupList.push(() => wrapper.removeEventListener('wheel', onWheel))
      })
    },
    handleDragEnd(event) {
      const { oldIndex, newIndex } = event
      if (oldIndex === newIndex) return
      const movedItem = this.tableData.splice(oldIndex, 1)[0]
      this.tableData.splice(newIndex, 0, movedItem)
      this.syncSerialNumbers()
      this.$emit('sort-change', this.tableData)
    },
    addNewRow() {
      const maxId = this.tableData.length > 0 ? Math.max(...this.tableData.map(item => Number(item.id) || 0)) : 0
      this.tableData.push({
        id: maxId + 1,
        triggerField: 'none',
        triggerValueType: 'static',
        triggerOperator: '=',
        triggerFieldValue: '',
        triggerFieldDynamic: '',
        formConfigId: '',
        fieldName: '',
        decimals: 2,
        exclusionRule: 'round',
        showTemplate: '',
        isEnable: '1',
        isNew: true,
        validationErrors: {}
      })
      this.syncSerialNumbers()
      this.$emit('sort-change', this.tableData)
    },
    validateRequiredFields() {
      let isValid = true
      let firstError = null
      this.tableData.forEach(row => {
        row.validationErrors = {}
        row.triggerField = this.normalizeTriggerField(row.triggerField)
        row.triggerOperator = this.normalizeTriggerOperator(row.triggerOperator || row.triggerCondition || '=')
        if (!row.triggerValueType) {
          row.triggerValueType = 'static'
        }
        if (!row.formConfigId || String(row.formConfigId).trim() === '') {
          row.validationErrors.formConfigId = '表名不能为空'
          isValid = false
        }
        if (!row.fieldName || String(row.fieldName).trim() === '') {
          row.validationErrors.fieldName = '字段名不能为空'
          isValid = false
        }
        const formulaText = (row.showTemplate != null ? row.showTemplate : row.template) || ''
        if (!String(formulaText).trim()) {
          row.validationErrors.showTemplate = '计算公式不能为空'
          isValid = false
          if (!firstError) firstError = { row, field: '计算公式' }
        }
        if (!this.isTriggerAlways(row.triggerField)) {
          if (['is_empty', 'not_empty'].includes(row.triggerOperator)) {
            return
          }
          if (row.triggerValueType === 'dynamic') {
            if (!row.triggerFieldDynamic) {
              row.validationErrors.triggerFieldValue = '请选择动态字段'
              isValid = false
              if (!firstError) firstError = { row, field: '条件值(动态字段)' }
            }
          } else if (!String(row.triggerFieldValue || '').trim()) {
            row.validationErrors.triggerFieldValue = '条件值不能为空'
            isValid = false
            if (!firstError) firstError = { row, field: '条件值' }
          }
        }
        if (!firstError) {
          if (row.validationErrors.formConfigId) firstError = { row, field: '表名' }
          else if (row.validationErrors.fieldName) firstError = { row, field: '目标字段' }
        }
      })
      return { isValid, firstError }
    },
    deleteRow(index) {
      this.$confirm('确定要删除这行数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.tableData.splice(index, 1)
          this.syncSerialNumbers()
          this.$emit('sort-change', this.tableData)
          this.$message({ message: '删除成功', type: 'success' })
        })
        .catch(() => {
          this.$message({ message: '已取消删除', type: 'info' })
        })
    },
    save() {
      this.syncSerialNumbers()
      const { isValid, firstError } = this.validateRequiredFields()
      if (!isValid) {
        const rowNo = firstError && firstError.row ? Number(firstError.row.serialNumber) + 1 : ''
        const fieldName = firstError && firstError.field ? firstError.field : '必填字段'
        this.$message({ message: rowNo !== '' ? `第${rowNo}行：请填写${fieldName}` : '请填写所有必填字段', type: 'error' })
        return
      }
      const replacements = []
      this.cascaderOption.forEach(table => {
        if (!Array.isArray(table.children)) return
        table.children
          .filter(field => field.dataType === 2 || field.dataType === 4)
          .forEach(field => {
            const userFriendlyVar = `${table.label}_${field.label}`
            const systemVar = `${table.value}_${field.fieldName}`
            replacements.push({ userFriendlyVar, systemVar, length: userFriendlyVar.length })
          })
      })
      replacements.sort((a, b) => b.length - a.length)

      const payload = clone(this.tableData).map(item => {
        const next = { ...item }
        next.triggerField = this.normalizeTriggerField(next.triggerField)
        next.triggerField = this.isTriggerAlways(next.triggerField) ? 'none' : String(next.triggerField)
        next.triggerValueType = next.triggerValueType === 'dynamic' ? 'dynamic' : 'static'
        next.triggerFieldDynamic = next.triggerValueType === 'dynamic' ? String(next.triggerFieldDynamic || '') : ''
        next.triggerFieldValue = this.formatTriggerValue(next)
        next.triggerOperator = this.normalizeTriggerOperator(next.triggerOperator || next.triggerCondition || '=')
        next.triggerCondition = next.triggerOperator
        const formulaText = ((next.showTemplate != null ? next.showTemplate : next.template) || '').trim()
        next.template = this.transformFormula(formulaText, replacements)
        next.showTemplate = formulaText
        if (next.isNew) delete next.id
        return next
      })

      this.dialogLoading = true
      submitFormulaInfo(payload, this.formConfigId)
        .then(() => {
          this.$message({ message: '保存成功', type: 'success' })
          this.dialogLoading = false
          this.getFormulaList()
        })
        .catch(err => {
          const message = (err && err.message) || '保存失败'
          this.$message({ message, type: 'error' })
          this.dialogLoading = false
        })
    },
    flattenTree(treeData, childrenKey = 'children') {
      const result = []
      function traverse(node, parent = null) {
        const flatNode = { ...node }
        if (parent) flatNode.parentId = parent.id
        result.push(flatNode)
        if (node[childrenKey] && Array.isArray(node[childrenKey])) {
          node[childrenKey].forEach(child => traverse(child, node))
        }
      }
      if (Array.isArray(treeData)) treeData.forEach(node => traverse(node))
      return result
    },
    getFieldList(row) {
      const form = this.configData.find(r => r.id === row.formConfigId)
      if (!form) return []
      let fields = form.fieldsConfigVOs || []
      if (form.parentId === '0') {
        fields = (form.itemsConfigVOs || []).flatMap(item => item.items || [])
      }
      return fields.filter(item => item.isShow && (item.showName || item.itemShowName) && (item.dataType === 2 || item.dataType === 4))
    },
    getTriggerFieldOptions(row) {
      return this.getFieldList(row)
    },
    getConditionFieldOptions(row) {
      const form = this.configData.find(r => r.id === row.formConfigId)
      if (!form) return []
      let fields = form.fieldsConfigVOs || []
      if (form.parentId === '0') {
        fields = (form.itemsConfigVOs || []).flatMap(item => item.items || [])
      }
      return fields.filter(item => item.isShow && (item.showName || item.itemShowName))
    },
    getTriggerFieldLabel(row, triggerFieldRef) {
      if (!triggerFieldRef) return ''
      const fieldId = String(triggerFieldRef).split(',')[1]
      const target = this.getConditionFieldOptions(row).find(item => String(item.id) === String(fieldId))
      return target ? target.showName || target.itemShowName : ''
    },
    isValueInputDisabled(row) {
      if (this.isTriggerAlways(row.triggerField)) return true
      return ['is_empty', 'not_empty'].includes(row.triggerOperator)
    },
    handleFormConfigChange(row) {
      row.fieldName = ''
      row.triggerField = 'none'
      row.triggerValueType = 'static'
      row.triggerOperator = '='
      row.triggerFieldValue = ''
      row.triggerFieldDynamic = ''
    },
    getCascader() {
      const result = [{ label: '无', value: 'none' }]
      this.configData.forEach(item => {
        const option = { label: item.header, value: item.id }
        let fields = item.fieldsConfigVOs || []
        if (item.parentId === '0') {
          fields = (item.itemsConfigVOs || []).flatMap(formItem => formItem.items || [])
        }
        option.children = fields
          .filter(field => field.isShow && (field.showName || field.itemShowName))
          .map(field => ({
            label: field.showName || field.itemShowName,
            value: `${field.id}`,
            dataType: field.dataType,
            fieldName: field.itemName || field.fieldName
          }))
        result.push(option)
      })
      this.cascaderOption = result
    },
    isTriggerAlways(triggerField) {
      const normalized = this.normalizeTriggerField(triggerField)
      if (!normalized || normalized === 'none') return true
      if (Array.isArray(normalized)) return normalized.length === 0 || normalized.includes('none')
      return false
    },
    renderTriggerField(row) {
      if (this.isTriggerAlways(row.triggerField)) return '无'
      return this.getTriggerFieldLabel(row, row.triggerField) || String(row.triggerField)
    },
    renderTriggerValue(row) {
      if (row.triggerValueType === 'dynamic') {
        const label = this.getTriggerFieldLabel(row, row.triggerFieldDynamic)
        if (row.triggerOperator === 'is_empty') return '空'
        if (row.triggerOperator === 'not_empty') return '非空'
        return label ? `${row.triggerOperator || '='} 动态字段: ${label}` : '-'
      }
      if (row.triggerOperator === 'is_empty') return '空'
      if (row.triggerOperator === 'not_empty') return '非空'
      return row.triggerFieldValue ? `${row.triggerOperator || '='} ${row.triggerFieldValue}` : '-'
    },
    handleEditor(row) {
      this.showEditor = true
      this.editorRow = row
    },
    handleConfirm(formulaStr) {
      this.editorRow.showTemplate = formulaStr
      this.showEditor = false
    },
    transformFormula(formula, replacements) {
      let transformedFormula = formula
      replacements.forEach(({ userFriendlyVar, systemVar }) => {
        const escapedVar = userFriendlyVar.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        const regex = new RegExp(escapedVar, 'g')
        transformedFormula = transformedFormula.replace(regex, systemVar)
      })
      return transformedFormula
    }
  }
}
</script>

<style lang="scss" scoped>
.list-header {
  margin-bottom: 6px;
  text-align: right;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

/deep/ .calculate-list {
  margin: -20px -20px;
  padding: 15px;
  background: #fff;
  border-radius: 4px;

  .formula-content,
  .formula-input {
    font-family: monospace;
    color: #333;
  }

  .drag-icon {
    cursor: move;
    font-size: 18px;
    color: #909399;
    transition: color 0.2s;
    &:hover {
      color: #409eff;
    }
  }

  .el-icon-edit {
    cursor: default !important;
    color: #000;
  }

  .input-with-error {
    width: 100%;
    position: relative;
  }

  .error-message {
    font-size: 12px;
    color: #f56c6c;
    margin-top: 4px;
    text-align: left;
    line-height: 1.2;
  }

  .trigger-value-editor {
    display: flex;
    gap: 8px;
  }

  .trigger-type {
    width: 92px;
    flex: none;
  }

  .trigger-operator {
    width: 72px;
    flex: none;
  }

  .trigger-value {
    flex: 1;
  }

  .el-table .el-input__inner,
  .el-table .el-textarea__inner,
  .el-table .el-input-number__decrease,
  .el-table .el-input-number__increase {
    border: 0 !important;
    box-shadow: none !important;
    background: transparent;
  }

  .el-table .el-input.is-focus .el-input__inner,
  .el-table .el-textarea__inner:focus {
    border: 0 !important;
    box-shadow: none !important;
  }
}

.button-group {
  margin: 20px 0;
  display: flex;
  gap: 15px;
}

.result-section {
  margin-top: 30px;
  text-align: left;
}

.formula-display {
  background: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  font-family: monospace;
  margin-top: 10px;
}
</style>

<style>
.sortable-ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
